/* © NXAPP Limited */

/**
 * Supabase throws PostgrestError-shaped plain objects, not Error instances, so
 * String(err) yields "[object Object]". Pull out the fields that actually say
 * what went wrong.
 */
export function describeError(err: unknown): string {
  if (err instanceof Error && err.message) return err.message
  if (err && typeof err === 'object') {
    const e = err as Record<string, unknown>
    const parts = [e.message, e.details, e.hint].filter(v => typeof v === 'string' && v.trim()) as string[]
    const code = typeof e.code === 'string' && e.code ? `[${e.code}] ` : ''
    if (parts.length) return code + parts.join(' — ')
    try { return JSON.stringify(err) } catch { /* fall through */ }
  }
  return String(err)
}
